module.exports = __webpack_public_path__ + "img/3.685af475.svg";